export enum OrganizationPostTypes {
    Update = 1,
    Need = 2,
    Event = 3
}
